<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view/>
    <!--页面返回不刷新-->
    <!-- <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view> -->
    <!-- <el-row>
        <el-col :span="2" class="bg-box">
          <NavBar></NavBar>
        </el-col>
        
        <el-col :span="22">
          <router-view/>
        </el-col>
    </el-row> -->
  </div>
</template>

<script>

import NavBar from '@/components/content/navbar/NavBar.vue'

export default {

  components: {
    NavBar
  },
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 30px;
  /* 背景设置 */
  background-color: rgba(245, 245, 245, 1);
  height: 100vh;
  margin: 0px;
  padding: 0px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue